import { makeStyles } from '@mui/styles';
import { CustomTheme } from 'types/theme';

export const useStyles = makeStyles((theme: CustomTheme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#FFFFFF',
    padding: 18
  },
  backIcon: {
    position: 'absolute',
    height: 24,
    width: 24,
    left: 18,
    color: '#0000008A',
    cursor: 'pointer'
  },
  avatarIcon: {
    right: 18,
    '&.MuiAvatar-root': {
      position: 'absolute',
      background: '#00000014',
      color: theme.palette.text.secondary,
      height: 32,
      width: 32,
      padding: 3
    }
  },
  logo: {
    width: 59,
    height: 25
  }
}));
